import { oidcStorageKey } from "../constants";
import config from "../../../config";

export function getProfileCheckerAuthQueryParams():
  | Record<string, string>
  | undefined {
  const params = new URLSearchParams(window.location.search);

  const provider = params.get("provider");

  if (provider) return { acr_values: `idp:${provider}` };
}

// temporary solution until will be done SL-7896
export function oidcLogout() {
  localStorage.removeItem(oidcStorageKey);
  window.location.replace(config.portalApiLogoutUrl);
}
